<!-- src/views/ResponsePage.vue -->
<template>
  <div class="page response-page">

    <!-- Top bar header -->
    <header class="header">
      <div class="logo">
        <img src="@/assets/taxscanai-logo.png" alt="Taxscan Logo" />
      </div>
      <button class="logout-button" @click="logout">
        <span class="desktop-label">Signout</span>
        <span class="mobile-label">S</span>
      </button>
    </header>


    <h1>Taxscan AI Response</h1>
    <!-- Subheading or short explanation -->
    <p class="subheading">Below is the AI-generated summary based on your question.</p>

    <div class="response-container" ref="pdfContainer">
      <div v-html="responseHTML"></div>
    </div>

    <!-- Buttons Row -->
    <div class="response-actions">
      <button @click="copyToClipboard" class="default-button">📋 Copy</button>
      <button @click="downloadPDF" class="default-button">📄 Download PDF</button>
    </div>

    <!-- CTA to ask another question -->
    <button @click="askAgain" class="ask-again-button">Ask Another Question</button>

  </div>
  <footer class="footer">
      <p>© {{ new Date().getFullYear() }} Taxscan Edutech Private Limited. All rights reserved.</p>
  </footer>
</template>

<script>
import html2pdf from 'html2pdf.js/dist/html2pdf.min';
import { marked } from 'marked';



export default {
  name: 'ResponsePage',
  data() {
    return {
      responseHTML: '',
    };
  },
  mounted() {
  // In mounted() or before parsing the response
  let storedResponse = localStorage.getItem('ai_response') || '';

  // 1) Check if it starts with "Retrieved Information" (case-insensitive)
  // 2) Remove it if found
  //storedResponse = storedResponse.replace(/^retrieved information[:-]?\s*/i, '');
  storedResponse = storedResponse.replace(/\\n/g, '\n');

  // Then parse via marked
  this.responseHTML = marked.parse(storedResponse);

  },
  methods: {
    
    copyToClipboard() {
      // Copy the HTML content as text (stripping HTML might be better if you want plain text)
      const tempElement = document.createElement('div');
      tempElement.innerHTML = this.responseHTML;
      const textToCopy = tempElement.textContent || tempElement.innerText || '';

      navigator.clipboard.writeText(textToCopy).then(() => {
        alert('📋 Response copied to clipboard!');
      });
    },
    downloadPDF() {
      // Retrieve the element via the ref
      const element = this.$refs.pdfContainer;
      // Pass it to html2pdf
      html2pdf().from(element).save('AI_Response.pdf');
    }
,
    askAgain() {
      // Clear data and go home or ask page
      localStorage.removeItem('ai_response');
      this.$router.push('/');
    },
    logout() {
      localStorage.removeItem('auth_token');
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
/* Container layout */
.response-page {
  font-family: 'Poppins', sans-serif;
  min-height: 100vh;
  background: linear-gradient(135deg, #e2f3f5 0%, #ffffff 100%);
  padding-top: 60px; /* Offset the fixed header */
  text-align: center;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

.response-page h1 {
  margin-bottom: 10px;
  font-size: 1.75rem;
}

.subheading {
  font-size: 1rem;
  color: #666;
  margin-bottom: 20px;
}

/* The card-like container for the response text */
.response-container {
  text-align: left;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  line-height: 1.6;
  font-size: 16px;
  word-break: break-word;
  margin: 0 auto;   /* Center horizontally if needed */
  max-width: 100%;
  width: 100%;
}

/* If you want to style headings/lists inside the response */
.response-container h1,
.response-container h2,
.response-container h3 {
  margin-top: 1em;
  color: #333;
}

.response-container ul {
  list-style-type: none; /* Removes the default bullet points */
  padding-left: 0;       /* Removes any left padding that may indent the list */
  margin: 0;             /* Adjust margin as desired */
}

.response-container li {
  list-style: none;      /* Ensures list items don't display markers */
}

::v-deep .response-container ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

::v-deep .response-container li {
  list-style: none;
}


/* Buttons row */
.response-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 15px;
}

/* Reusable button styles */
.default-button {
  flex: none;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: 0.3s;
}
.default-button:hover {
  background-color: #0056b3;
}

/* "Ask Another Question" CTA */
.ask-again-button {
  display: block;
  width: 100%;
  max-width: 400px;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background-color: #4caf50;
  color: white;
  transition: 0.3s;
  margin: 20px auto 0; /* top auto bottom => center horizontally, some top margin */
}
.ask-again-button:hover {
  background-color: #45a049;
}


.icon-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.icon-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 6px 8px;
  position: absolute;
  z-index: 999;
  bottom: 125%; /* Position above the icon */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.logout-button {
  background: #007bff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
  transition: background-color 0.3s;
}

.logout-button:hover {
  background: #0056b3;
}

.logout-button .mobile-label {
  display: none;
}

@media (max-width: 768px) {
  .logo img {
    max-height: 100px;
  }
  .logout-button .desktop-label {
    display: none;
  }
  .logout-button .mobile-label {
    display: inline;
  }
  .footer {
    font-size: 11px; /* or any size you prefer for mobile devices */
  }
  .response-container {
    font-size: 13px; /* or any size you prefer for mobile devices */
  }
  .response-page h1 {
    font-size: 15px;
  }
  .response-page p {
    font-size: 13px;
  }
}


/* Header that spans full width */
.page-header {
  width: 100%;
  display: flex;
  justify-content: flex-end; /* Moves icon to the right */
  align-items: center;
  margin-bottom: 20px;
  /* If you want the header pinned to top, see step 3 for absolute positioning */
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.logo img {
  max-height: 140px;
  transition: max-height 0.3s;
}
</style>

